import React, { FC, useState } from 'react';
import { serverSideTranslation } from '../../../util/next';
import NewsFooter from '../../../modules/NewsFooter';
import TimeHonoredFooter from '../../../modules/TimeHonoredFooterv2';
import { useScrollRef } from '../../../modules/Laozihao/hooks/useScrollRef';
import BannerCard from '../../../components/BannerCard';
import { TitleColCard } from '../../../components/TitleCard';
import CooperativeEnterprise from '../../../components/CooperativeEnterprise';
import { getPageContent } from '../../../api/pagesApi';
import Page from '../../../components/Layout/Page';

import { Modal } from '../../../modules/Laozihao';

interface Props {
  pageContentData: any;
  _nextI18Next: any;
}

const TimeHonored: FC<Props> = (props) => {
  const { pageContentData, _nextI18Next: i18n } = props;
  const { pageContent = {}, shareContent = {} } = pageContentData || {};
  const {
    modalConfig,
    bannerCardConfig,
    brandValueConfig,
    digitalBusinessConfig,
    moreServiceConfig,
    cooperativeConfig,
  } = pageContent || {};
  const [visible, setVisible] = useState(false);

  const scrollRef = useScrollRef<HTMLDivElement>(setVisible);

  const description = shareContent.shareDetail || '老字号服务包';
  const title = shareContent.shareTitle || '美团';

  return (
    <>
      <Page description={description} title={title}>
        <div className="bg-[#f7f8f9]">
          <BannerCard
            {...bannerCardConfig}
            extra={
              <div ref={scrollRef}>
                <Modal lanType={i18n.initialLocale} modalConfig={modalConfig} />
              </div>
            }
          />
          <TitleColCard {...brandValueConfig} />
          <TitleColCard {...digitalBusinessConfig} />
          <TitleColCard {...moreServiceConfig} />
          <CooperativeEnterprise {...cooperativeConfig} />
          {visible && (
            <TimeHonoredFooter
              {...bannerCardConfig}
              extra={<Modal lanType={i18n.initialLocale} modalConfig={modalConfig} />}
            />
          )}

          {/* 底部新闻模块 */}
          <div className="mt-15 bg-[#fff] pt-5 lg:mt-25 lg:px-5">
            <NewsFooter category={4} lanType={i18n.initialLocale} positionNo="csr_9" />
          </div>
        </div>
      </Page>
    </>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr/industry/time-honored',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_047vma69',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common'])),
    },
  };
}
export default TimeHonored;
